// extracted by mini-css-extract-plugin
export default {"slide":"Slider_slide__sAkmo","nav":"Slider_nav__t+j6V","hideDeskNav":"Slider_hideDeskNav__XNK7+"};